import React, { FC } from 'react';

import { format } from 'date-fns';

import { DAY_FORMAT_WITH_SLASHES } from 'constants/dateFormats';
import { ButtonVariants } from 'constants/shared/button';
import { selectDealDetails } from 'modules/deals/selectors';
import { useAppSelector } from 'modules/store';
import ShareExchangeRequestTransactionSummary from 'page-components/my-investments/start-investment-share-exchange-page/ShareExchangeRequestTransactionSummary';
import { Button, ModalWindow, TitleWithDescription } from 'shared-components';
import Typography from 'shared-components/Typography';

type Props = {
  isOpen: boolean;
  onClose: VoidFunction;
};

const ShareExchangeDetailsModal: FC<Props> = ({ isOpen, onClose }) => {
  const { companyName, dealExchanges, closingDate } = useAppSelector(selectDealDetails) || {};
  const formatedClosingDate = closingDate ? format(new Date(closingDate), DAY_FORMAT_WITH_SLASHES) : '';

  return (
    <ModalWindow
      title={`Share Exchange Details: ${companyName}`}
      description=''
      isOpen={isOpen}
      onClose={onClose}
      className='min-w-[80%]'
      descriptionClassName='pt-6 pb-1'
      wrapperClassName='px-8 py-8 lg:px-8 lg:py-8'
      overlayClassName='bg-black opacity-80'
    >
      <ShareExchangeRequestTransactionSummary dealExchanges={dealExchanges} companyName={companyName} />
      <Typography className='px-4 py-6 opacity-80'>
        Closing date: <b>{formatedClosingDate}</b>
      </Typography>
      <Button className='w-full mt-10' type='button' variant={ButtonVariants.SECONDARY} onClick={onClose}>
        Close
      </Button>
    </ModalWindow>
  );
};

export default ShareExchangeDetailsModal;
